import getoffer from './get-offer'
import szzgscnr from './szzgscnr'
import zgsc from './zgsc'
export default {
    path: 'kaibiao',
    component: () => import(/*webpackChunkName: 'bidding-kaibiao'*/ '@layout/empty'),
    children: [
        getoffer,
        szzgscnr,
        zgsc
    ]
}